import './downloads.scss';

import { Navigation, A11y } from 'swiper/modules';

class Downloads {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-downloads'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$downloads = $element;
        this.$downloadsSlider = this.$downloads.querySelector('[' + this.settings.initAttr + '="slider"]');
        this.$$downloadsSlides = this.$downloads.querySelectorAll('[' + this.settings.initAttr + '="slide"]');
        this.slider = null;

        this.resizeHandler = window.resizeHandler;
        this.sliderActive = false;

        if (this.$downloadsSlider && this.$$downloadsSlides.length > 1) {
            import(
                /* webpackChunkName: "slider/slider.js" */
                './../../components/slider/slider').then(({ Slider }) => {
                this.Slider = Slider;
                this.initialize();
            });
            // this.initialize();
        }
    }

    initialize () {
        console.log('Downloads');
        this.checkSize();
        this.resizeHandler.customFunctions.push(() => {
            this.checkSize();
        });
    }

    checkSize () {
        if (window.innerWidth < 768 && this.$$downloadsSlides.length > 1) {
            if (this.sliderActive === false) {
                this.initSlider();
            }
        } else {
            if (this.sliderActive === true) {
                this.destroySlider();
                this.sliderActive = false;
            }
        }
    }

    initSlider () {
        this.slider = new this.Slider(this.$downloadsSlider, {
            modules: [A11y, Navigation],
            speed: 500,
            slidesPerView: 'auto',
            slidesPerGroup: 1,
            spaceBetween: 15,
            centeredSlides: true,
            centeredSlidesBounds: true,
            initAttr: this.settings.initAttr,
            centerInsufficientSlides: true,
            prevnext: true
        });

        this.sliderActive = true;
    }

    destroySlider () {
        if (typeof this.slider !== 'undefined' && this.slider !== null) {
            this.slider.destroy();
        }
    }
}

export { Downloads };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$downloads = $context.querySelectorAll('[data-downloads="root"]');
        for (let i = 0; i < $$downloads.length; i++) {
            const $downloads = $$downloads[i];

            const downloadsAPI = new Downloads($downloads);
            $downloads.API = downloadsAPI;
        }
    }
});
